import { supabase } from '../lib/supabase'
import type { Database } from '../lib/supabase'

type Article = Database['public']['Tables']['articles']['Row']
type ArticleInsert = Database['public']['Tables']['articles']['Insert']
type ArticleUpdate = Database['public']['Tables']['articles']['Update']

export const articlesService = {
  // Hämta alla artiklar
  async getAll(): Promise<Article[]> {
    const { data, error } = await supabase
      .from('articles')
      .select('*')
      .order('name')
    
    if (error) {
      console.error('Error fetching articles:', error)
      throw error
    }
    
    return data || []
  },

  // Hämta artikel efter ID
  async getById(id: string): Promise<Article | null> {
    const { data, error } = await supabase
      .from('articles')
      .select('*')
      .eq('id', id)
      .single()
    
    if (error) {
      console.error('Error fetching article:', error)
      throw error
    }
    
    return data
  },

  // Skapa ny artikel
  async create(article: ArticleInsert): Promise<Article> {
    const { data, error } = await supabase
      .from('articles')
      .insert([article])
      .select()
      .single()
    
    if (error) {
      console.error('Error creating article:', error)
      throw error
    }
    
    return data
  },

  // Uppdatera artikel
  async update(id: string, updates: ArticleUpdate): Promise<Article> {
    const { data, error } = await supabase
      .from('articles')
      .update({ ...updates, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single()
    
    if (error) {
      console.error('Error updating article:', error)
      throw error
    }
    
    return data
  },

  // Ta bort artikel
  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('articles')
      .delete()
      .eq('id', id)
    
    if (error) {
      console.error('Error deleting article:', error)
      throw error
    }
  },

  // Hämta artiklar efter kategori
  async getByCategory(category: string): Promise<Article[]> {
    const { data, error } = await supabase
      .from('articles')
      .select('*')
      .eq('category', category)
      .order('name')
    
    if (error) {
      console.error('Error fetching articles by category:', error)
      throw error
    }
    
    return data || []
  },

  // Hämta RUT-applicerade artiklar
  async getRutApplicable(): Promise<Article[]> {
    const { data, error } = await supabase
      .from('articles')
      .select('*')
      .eq('is_rut_applicable', true)
      .order('name')
    
    if (error) {
      console.error('Error fetching RUT articles:', error)
      throw error
    }
    
    return data || []
  }
}


